<div class="timeline-view">
  <div class="timeline-header">
    <div class="task-list-header">Task</div>
    <div class="task-list-header">Timeline</div>
  </div>

  <div class="timeline-body-wrapper">
    <div class="task-list-panel">
      @for (task of sortedTimelineTasks$ | async; track task.task_id) {
        <div class="task-list-item">
          {{ task.name }}
        </div>
      }
    </div>

    <div class="gantt-chart-area">
      <div class="today-line" [style.left.%]="todayPosition"></div>
      @for (task of sortedTimelineTasks$ | async; track task.task_id) {
        <div class="gantt-row">
          <div
            class="task-bar"
            [class]="getStatusClass(task.status)"
            [style.left.%]="task.barLeft"
            [style.width.%]="task.barWidth"
            matTooltip="{{ task.name }} ({{ task.created_at * 1000 | date }} - {{ task.due_date | date }})">
            <span class="bar-name">{{ task.created_at * 1000 | date: 'MMM d' }}</span
            ><span class="bar-name">{{ task.due_date | date: 'MMM d' }} </span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
